export const getReviewCountText = (reviewCount: number) => {
  if (reviewCount < 10) {
    return 'under 10';
  }

  const getFactor = () => {
    if (reviewCount >= 1000) {
      return 100;
    }
    if (reviewCount >= 100) {
      return 50;
    }
    return 10;
  };

  const rounded = Math.floor(reviewCount / getFactor()) * getFactor();

  // We are returning 'over' because we want to show the review count as a range, not a specific number.
  return `over ${rounded.toLocaleString()}`;
};
